import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { useSnackbar } from 'notistack';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress } from '@material-ui/core';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import AddInteriorItem from './AddInteriorItem'
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import RemarksDynamicField from "../../../shared/components/RemarksDynamicField";
import { downloadFileType } from "../../../utils";
import { assetTypeValues, backendDateFormat } from "../../../constants";
import moment from "moment";
import { trackActivity } from "../../../utils/mixpanel";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { arrayMoveImmutable } from "array-move";
import { regexConstants } from "../../../constants/regEx";

const crewSeatObj = {
    type_of_seat: null,
    location: null,
    part_number: '',
    serial_number: '',
    manufacturer: '',
    remarks: ''
}
const CrewSeatHd = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '120px' }}>Action(s)</TableCell>
                <TableCell>Seat Type</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Part Number</TableCell>
                <TableCell>Serial Number</TableCell>
                <TableCell>Manufacturer</TableCell>
                <TableCell>ATA Code</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Remarks</TableCell>
            </TableRow>
        </TableHead>
    )
}
const SortableBodyContainer = SortableContainer(({ crewSeatsInfo, setAddEditCrewSeat, setDeleteCrewSeat }) => {
    return (
        <TableBody>
            {crewSeatsInfo.list.map((item, index) =>
                <CrewSeatList
                    key={`item-${index}`}
                    index={index}
                    sortIndex={index}
                    item={item}
                    onEdit={() => setAddEditCrewSeat({ modal: true, data: item })}
                    onDelete={() => setDeleteCrewSeat({ modal: true, data: item })}
                />
            )}
        </TableBody>
    );
});

const DragHandle = SortableHandle(() => <span style={{ paddingRight: '10px', display: 'inline-block', cursor: 'move', width: '10%' }}><DragIndicatorIcon /></span>);
const CrewSeatList = SortableElement(({ item, onEdit, onDelete }) => {
    return (
        <TableRow>
            <TableCell align="left" style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
                <ul className="list-inline" style={{ width: '120px' }}>
                    {
                        checkPermission('technical_specs', 'interior', 'U') ?
                            <li className="list-inline-item hover-inline" onClick={onEdit}>
                                <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    {
                        checkPermission('technical_specs', 'interior', 'D') ?
                            <li className="list-inline-item hover-inline" onClick={onDelete}>
                                <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    <li className="list-inline-item hover-inline"><DragHandle /></li>
                </ul>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '140px' }}>{item?.type_of_seat?.label || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '140px' }}>{item?.location?.label || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '140px' }}>{item?.part_number || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '140px' }}>{item?.serial_number || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '140px' }}>{item?.manufacturer || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '140px' }}>{item?.ata_code || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ maxWidth: '140px' }}>{item?.quantity || '--'}</div>
            </TableCell>
            <TableCell>
                <RemarksDynamicField
                    item={item}
                />
            </TableCell>
        </TableRow>
    )
})
const AddEditCrewSeat = ({ params, addEditCrewSeat, toggleModalFn, getResponseBack, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [crewSeat, setCrewSeat] = useState(addEditCrewSeat.data);
    const [pltConstants, setPltConstants] = useState([]);
    const [error, setError] = useState({});
    useEffect(() => {
        globalPostService('console/get-constants/', { constant_types: ['crew_seat_type', 'interior_location'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }, [])
    const onFieldChange = (key, value) => {
        if (key === 'type_of_seat') {
            if (value && (value.value === 1 || value.value === 2)) {
                setCrewSeat({ ...crewSeat, [key]: value, location: { label: 'FWD', value: 1 } })
            } else {
                setCrewSeat({ ...crewSeat, [key]: value, location: null })
            }
        } else {
            setCrewSeat({ ...crewSeat, [key]: value })
        }

    }
    const onAddEditCrewSeat = () => {
        let validationInputs = {
            type_of_seat: crewSeat?.type_of_seat ? '' : 'Please select Type of Seat',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            if (crewSeat.id) {
                globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/interior/crew-seating/${crewSeat.id}/`, crewSeat)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            toggleModalFn(); getResponseBack();
                            trackActivity('Console Management', { data:JSON.stringify(crewSeat), page_title: 'Crew seat', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Crew Seat data from Edit Crew Seat form' })
                        }
                        setLoading(false)
                    })
            } else {
                globalPostService(`console/v2/${params.type}/${params.aircraft_slug}/interior/crew-seating/`, crewSeat)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            trackActivity('Console Management', {data:JSON.stringify(crewSeat), page_title: 'Crew seat', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Added Crew Seat data from Add Crew Seat form' })
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false)
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    return (
        <Dialog
            open={addEditCrewSeat.modal}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {crewSeat?.id ? 'Edit ' : 'Add '} Crew Seat
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <Autocomplete
                            options={pltConstants.filter(optionItem => optionItem.type === 'crew_seat_type')}
                            getOptionLabel={option => option.label}
                            name="type_of_seat"
                            value={crewSeat?.type_of_seat || null}
                            onChange={(e, value) => { onFieldChange('type_of_seat', value); setError({ ...error, 'type_of_seat': '' }) }}
                            renderInput={params => <TextField required error={error?.type_of_seat} helperText={error?.type_of_seat || ''} {...params} label="Type of Seat" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <Autocomplete
                            disabled={(crewSeat?.type_of_seat?.value === 1 || crewSeat?.type_of_seat?.value === 2)}
                            options={pltConstants.filter(optionItem => optionItem.type === 'interior_location')}
                            getOptionLabel={option => option.label}
                            name="location"
                            value={crewSeat?.location || null}
                            onChange={(e, value) => onFieldChange('location', value)}
                            renderInput={params => <TextField {...params} label="Location" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            name='part_number'
                            label='Part Number'
                            value={crewSeat?.part_number || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('part_number', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 25 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            name='serial_number'
                            label='Serial Number'
                            value={crewSeat?.serial_number || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('serial_number', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 25 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            name='manufacturer'
                            label='Manufacturer'
                            value={crewSeat?.manufacturer || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('manufacturer', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 50 }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            name='ata_code'
                            label='ATA Code'
                            value={crewSeat?.ata_code || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('ata_code', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 25 }}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            name='quantity'
                            label='Quantity'
                            value={crewSeat?.quantity || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange('quantity', e.target.value) : e.preventDefault()}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 10 }}
                            // error={error?.quantity}
                            // helperText={error?.quantity || ''}
                            // onFocus={() => setError({ ...error, 'quantity': '' })}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            name='remarks'
                            label='Remarks'
                            value={crewSeat?.remarks || ''}
                            fullWidth
                            margin="normal"
                            multiline
                            rows={3}
                            inputProps={{ maxLength: 250 }}
                            onChange={(e) => onFieldChange('remarks', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditCrewSeat} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const CrewSeat = ({ params, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [crewSeatsInfo, setCrewSeatsInfo] = useState({ list: [], pagination: null });
    const [addEditCrewSeat, setAddEditCrewSeat] = useState({ modal: false, data: null });
    const [deleteCrewSeat, setDeleteCrewSeat] = useState({ modal: false, data: null });
    useEffect(() => {
        getCrewSeats({per_page:50}, 'skeletonLoader');
    }, []);
    const getCrewSeats = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/interior/crew-seating/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setCrewSeatsInfo(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteCrewSeat = () => {
        setLoading(true);
        globalDeleteService(`console/v2/${params.type}/${params.aircraft_slug}/interior/crew-seating/${deleteCrewSeat.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteCrewSeat({ modal: false, data: null });
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    getCrewSeats({per_page: crewSeatsInfo?.pagination?.per_page}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    const onExportCrewSeat = () => {
        setLoading(true);
        globalExportService(`console/v2/aircraft/${params.aircraft_slug}/interior/crew-seating/?download=xlsx`)
            .then(response => {
                downloadFileType(response, `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}_Crew_Seat ${moment().format(backendDateFormat)}`, 'xlsx')
                trackActivity('Console Management', { page_title: 'Crew Seat', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Exported', event_desc: `Crew Seat Exported Successfully`, file_extension: 'xlsx' })
                setLoading(false)
            });
    }
    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex !== newIndex) {
            let newArray = arrayMoveImmutable(crewSeatsInfo?.list, oldIndex, newIndex)
            setLoading(true)
            setCrewSeatsInfo({...crewSeatsInfo, list:newArray})
            globalPutService(`console/v2/aircraft/${params.aircraft_slug}/interior/crew-seating/reorder/`, { order_list: newArray.map(item => item.id) })
                .then(response => {
                    setLoading(false)
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                })
        }
    }
    return (
        <div style={{ padding: '0px 10px' }}>
            {skeletonLoader ? <STableLoader count={7} size={7} /> :
                <>
                    <AddInteriorItem
                        addPermission={checkPermission('technical_specs', 'interior', 'C')}
                        exportPermission={checkPermission('technical_specs', 'interior', 'EXP')}
                        onAddItem={() => setAddEditCrewSeat({ modal: true, data: crewSeatObj })}
                        isExport
                        isImport
                        item={crewSeatsInfo}
                        onExport={() => onExportCrewSeat()}
                        getResponseBack={() => getCrewSeats({}, 'skeletonLoader')}
                        trackActivity={trackActivity('Console Management', { page_title: 'Crew Seat', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Imported', event_desc: `Cres Sear Imported Successfully`, file_extension: 'xlsx' })}
                        url={`/console/v2/aircraft/${params.aircraft_slug}/interior/crew-seating/import/`}
                    />
                    <Paper square>
                        <div style={{height:`${window.innerHeight -  (crewSeatsInfo?.list?.length ? 325 : 275)}px`,overflow:'auto',marginTop: "3px"}}>
                        <Table className='mui-table-format' stickyHeader>
                            <CrewSeatHd />
                            <SortableBodyContainer
                                useDragHandle
                                onSortEnd={onSortEnd}
                                crewSeatsInfo={crewSeatsInfo}
                                setAddEditCrewSeat={setAddEditCrewSeat}
                                setDeleteCrewSeat={setDeleteCrewSeat}
                            />
                        </Table>
                          {!crewSeatsInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    {crewSeatsInfo?.pagination ?
                        <Paper square>
                            <Pagination
                                pagination={crewSeatsInfo.pagination}
                                onChangePage={(event, newPage) => getCrewSeats({ ...filter, page: newPage + 1, per_page: crewSeatsInfo.pagination.per_page }, 'pageLoader')}
                                onChangeRowsPerPage={(event) => getCrewSeats({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                            />
                        </Paper>
                        : null
                    }
                </>
            }
            {addEditCrewSeat.modal ?
                <AddEditCrewSeat
                    params={params}
                    assetInfoData={assetInfoData}
                    addEditCrewSeat={addEditCrewSeat}
                    toggleModalFn={() => setAddEditCrewSeat({ modal: false, data: null })}
                    getResponseBack={() => getCrewSeats({per_page: crewSeatsInfo?.pagination?.per_page}, 'pageLoader')}
                /> : null
            }
            {deleteCrewSeat.modal ?
                <DeletePopUp
                    modal={deleteCrewSeat.modal}
                    title='Delete Crew Seat'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteCrewSeat({ modal: false, data: null })}
                    deleteRecordFn={onDeleteCrewSeat}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(CrewSeat);
